<script lang="ts">
	interface Props {
		strokeColor?: string
	}

	let { strokeColor = "black" }: Props = $props()
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M22.7249 10.0261C24.425 10.8989 24.425 13.1012 22.7249 13.9739L3.78592 23.6971C2.09898 24.5632 0 23.4688 0 21.7232V2.27682C0 0.531203 2.09897 -0.563162 3.78592 0.302902L22.7249 10.0261Z"
		class="svg-fill"
		fill={strokeColor}
	/>
</svg>

<style>
</style>
